import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { MatSlider, MatSliderThumb } from '@angular/material/slider';
import type { FormValueControl } from '@angular/forms/signals';
import { UiFieldControl } from '../../../basics/ui-field-control';

const DEFAULT_SLIDER_MAX = 100;

@Component({
  selector: 'fr8bot-ui-slider-field',
  imports: [MatSlider, MatSliderThumb],
  templateUrl: './slider-field.component.html',
  styleUrl: './slider-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SliderFieldComponent
  extends UiFieldControl
  implements FormValueControl<number | null>
{
  readonly value = model<number | null>(null);

  // Not `min`/`max`: `[formField]` owns those input names.
  readonly minValue = input(0);
  readonly maxValue = input(DEFAULT_SLIDER_MAX);
  readonly step = input(1);
  readonly defaultValue = input(0);

  /** The thumb always has a position: an empty value sits at `defaultValue`, clamped into range. */
  protected readonly position = computed(() =>
    Math.min(Math.max(this.value() ?? this.defaultValue(), this.minValue()), this.maxValue()),
  );

  protected onInput(event: Event): void {
    this.value.set(Number((event.target as HTMLInputElement).value));
  }
}
